import React, { useEffect, useRef, useState } from "react";
import lockIcon from "../../assets/images/DeathModuleNew/Feature.png";
import {
  postLoginSuccess,
  postUserOtp,
  postLoginId,
  postUserData,
  postClientOtpData,
} from "../../redux/slices/loginSlice";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import Loader from "../../components/styled-components/loader/loader";
import DEATH_API from "../../apis/death.api";
import ROUTES from "../../config/routes";
import Base64 from "../../utils/base64";
import { Button } from "antd";
import swal from "sweetalert";
import axios from "axios";
import "./OTPValidateV2.css";
import ResetPasswordV2 from "./ResetPasswordV2";
import { setAddClientButton, setDelegateUsers } from "../../redux/slices/financialAdvisorSlice";

const OTPValidateV2 = () => {
  const [otp, setOtp] = useState(Array(6).fill(""));
  const history = useHistory();
  const [userOtp, setuserOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const inputRefs = useRef([]);
  const userId = useSelector((state) => state.rootReducer.loginUser.userId);
  const userData = useSelector((state) => state.rootReducer.loginUser.UserData);
  const [token, setToken] = useState('')
  const [showResetPass, setResetPass] = useState(false)
  const [isResetSuccess, setResetSuccess] = useState(false)
  const [otpRes, setOtpRes] = useState({})
  const clientOTPData = useSelector(
    (state) => state.rootReducer.loginUser.clientOtpData
  );

  const dispatch = useDispatch();
  const assetPlanetClientName = "asset_planet_resource";
  const assetPlanetClientPassword = "a_p_creds";
  const basicCreds = Base64.btoa(
    assetPlanetClientName + ":" + assetPlanetClientPassword
  );

  const location = useLocation();
  const config = {
    headers: {
      "Content-type": "Application/json",
      Authorization: "Basic " + basicCreds,
    },
  };

  const getClientList = async () => {
    let responseData = await DEATH_API.fetchClientList();
    const newData =
      responseData.data &&
      responseData.data[0] &&
      responseData.data[0].users &&
      responseData.data[0].users;
    newData && newData.map((item, index) => (item["Status"] = false));

    localStorage.setItem("delegateUsers", JSON.stringify(newData));
    dispatch(setDelegateUsers(newData))
    setLoading(false);
    swal("Success", "Login Success", "success");
    console.log("here in otp validate");
    if (location.state && location.state.from && location.state.from.pathname) {
      history.push({
        pathname: location.state.from.pathname,
        state: { from: location.state.from },
        PathExact: location.PathExact,
      });
    } else {
      history.push("/delgateAccess");
    }
  };

  useEffect(() => {
    if (
      !userId ||
      userId === null ||
      userId === "" ||
      Object.keys(userData).length === 0
    ) {
      history.push("/login");
    } else if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);
  const inactiveRoles = ["inActive financial adviser client", "inActive Financial Advisor", "inactiveClient"]

  const handleClientOtpSuccess = async () => {
    try {
      setLoading(true);
      const res = await axios.post(
        `${ROUTES.BASE_URL}/auth-service/auth/verifyClientOTP`,
        {
          userName: clientOTPData.username,
          password: clientOTPData.password,
          otp: userOtp,
        },
        config
      );
      
      let outputObj = {};
      if (res.status === 200 && res.data.access_token) {
        dispatch(setAddClientButton(true))
        if(res.data.user && res.data.user.clientStatus==="change password"){
          setOtpRes(res.data)
          setResetPass(true)
          setToken(res.data.access_token)
          return
        }
        dispatch(postLoginSuccess(res.data));

        if (res.data.user.roles) {
          const loginRole = res.data.user.roles;
          if (loginRole.test111) {
            localStorage.setItem(
              "role",
              JSON.stringify(loginRole.test111.name)
            );
          } else if (loginRole.protrustee) {
            localStorage.setItem(
              "role",
              JSON.stringify(loginRole.protrustee.name)
            );
          } else if (loginRole.superAdmin) {
            localStorage.setItem(
              "role",
              JSON.stringify(loginRole.superAdmin.name)
            );
          } else {
            let recursive = (obj, name) => {
              for (let key in obj) {
                if (typeof obj[key] == "object") {
                  recursive(obj[key], name + "_" + key);
                } else {
                  outputObj[key] = obj[key];
                }
              }
            };
            recursive(loginRole, "loginRole");
            localStorage.setItem("role", JSON.stringify(outputObj.name));
          }
        }
        localStorage.setItem("userData", JSON.stringify(res.data.user));
        localStorage.setItem("User", res.data.user.name);
        if (res.data.user.image !== null) {
          localStorage.setItem("profile", res.data.user.image);
        }
        localStorage.setItem("userName", res.data.user.userName);
        dispatch(postLoginId(res.data.id));
        localStorage.setItem("userLoginToken", res.data.access_token);

        if (res.data.user.permissions) {
          let permissions = res.data.user.permissions;
          const namesArray = Object.values(permissions).map(
            (permission) => permission.name
          );
          localStorage.setItem("permissionState", JSON.stringify(namesArray));

          // dispatch(postPermissionsSuccess(namesArray));
        }

        if (res.data.access_token) {
          setLoading(true);
          console.log("here in getting delegateusers");
          let newData = [];
          setLoading(false);

          if (
            location.state &&
            location.state.from &&
            location.state.from.pathname
          ) {
            history.push({
              pathname: location.state.from.pathname,
              state: { from: location.state.from },
              PathExact: location.PathExact,
            });
          } else {
            if (newData.length > 0) {
              history.push("/dashboard");
            } else {
              if (inactiveRoles.includes(outputObj.name)) {
                history.push("/payment");
              } else {
                history.push("/dashboard");
              }
            }
          }

          dispatch(postClientOtpData({}));
        }
      } else {
        // history.push("/otpvalidation");
        // swal("ERROR!", "While Login....")
      }
    } catch (error) {
      setLoading(false);
      // swal("Oops!", error.response.data.message, "error");
      if(error && error.response && error.response.data && error.response.data.message){

        swal("Oops!", error.response.data.message, "error", {
          buttons: {
            confirm: true,
          },
        }).then(() => {
          if (inputRefs && inputRefs.current) {
            const lastIndex = inputRefs.current.findIndex(
              (ref) => ref && !ref.value
            );
            const focusIndex =
              lastIndex !== -1 ? lastIndex : inputRefs.current.length - 1;
  
            if (inputRefs.current[focusIndex]) {
              inputRefs.current[focusIndex].focus();
            }
          }
        });
        console.log("error in otp", error.response);
      }

    }
  };

  const handleOtpSuccess = async () => {
    try {
      setLoading(true);
      const res = await axios.post(
        `${ROUTES.BASE_URL}/auth-service/auth/verifyOTP`,
        { id: userId, otp: userOtp },
        config
      );
      if (res.status === 200 && res.data.access_token) {
        // swal('Success', "Login Success", 'success')
        dispatch(postLoginSuccess(res.data));
        dispatch(postUserOtp(userOtp));
        dispatch(setAddClientButton(true))
        localStorage.setItem("userData", JSON.stringify(res.data.user));
        localStorage.setItem("User", res.data.user.name);
        if (res.data.user.image !== null) {
          localStorage.setItem("profile", res.data.user.image);
        }

        localStorage.setItem("userLoginToken", res.data.access_token);
        if (res.data.user.roles) {
          if (res.data.user.roles && res.data.user.roles.protrustee) {
            localStorage.setItem(
              "role",
              JSON.stringify(res.data.user.roles.protrustee.name)
            );
          } else {
            let outputObj = {};
            let recursive = (obj, name) => {
              for (let key in obj) {
                if (typeof obj[key] == "object") {
                  recursive(obj[key], name + "_" + key);
                } else {
                  outputObj[key] = obj[key];
                }
              }
            };
            recursive(res.data.user.roles, "loginRole");
            localStorage.setItem("role", JSON.stringify(outputObj.name));
          }
        } else if (res.data.trustee_Role && res.data.trustee_Role.roleName) {
          localStorage.setItem(
            "role",
            JSON.stringify(res.data.trustee_Role.roleName)
          );
        }
        if (res.data.user.permissions) {
          let permissions = res.data.user.permissions;
          const namesArray = Object.values(permissions).map(
            (permission) => permission.name
          );
          localStorage.setItem("permissionState", JSON.stringify(namesArray));
        }
        dispatch(postUserData({}));
        dispatch(postLoginId(""));

        getClientList();
      }
    } catch (error) {
      setLoading(false);
      // swal("Oops!", error.response.data.message, "error");
      swal("Oops!", error.response.data.message, "error", {
        buttons: {
          confirm: true,
        },
      }).then(() => {
        if (inputRefs && inputRefs.current) {
          const lastIndex = inputRefs.current.findIndex(
            (ref) => ref && !ref.value
          );
          const focusIndex =
            lastIndex !== -1 ? lastIndex : inputRefs.current.length - 1;

          if (inputRefs.current[focusIndex]) {
            inputRefs.current[focusIndex].focus();
          }
        }
      });

      console.log(error);
    }
  };

  const reSendOTP = async () => {
    if (clientOTPData.hasOwnProperty("username")) {
      try {
        setLoading(true);
        const res = await axios.post(
          `${ROUTES.BASE_URL}/auth-service/auth/signinClient`,
          clientOTPData,
          config
        );
        if (res.data.status === 200) {
          console.log("responsse of login", res.data.id);
          // swal("Success", res.data.message, "success");
          swal("Success", res.data.message, "success", {
            buttons: {
              confirm: true,
            },
          }).then(() => {
            if (inputRefs && inputRefs.current) {
              const lastIndex = inputRefs.current.findIndex(
                (ref) => ref && !ref.value
              );
              const focusIndex =
                lastIndex !== -1 ? lastIndex : inputRefs.current.length - 1;

              if (inputRefs.current[focusIndex]) {
                inputRefs.current[focusIndex].focus();
              }
            }
          });
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    } else {
      try {
        setLoading(true);
        const res = await axios.post(
          `${ROUTES.BASE_URL}/auth-service/auth/signin`,
          userData,
          config
        );
        if (res.data.status === 200) {
          console.log("responsse of login", res.data.id);
          // swal("Success", res.data.message, "success");
          swal("Success", res.data.message, "success", {
            buttons: {
              confirm: true,
            },
          }).then(() => {
            if (inputRefs && inputRefs.current) {
              const lastIndex = inputRefs.current.findIndex(
                (ref) => ref && !ref.value
              );
              const focusIndex =
                lastIndex !== -1 ? lastIndex : inputRefs.current.length - 1;

              if (inputRefs.current[focusIndex]) {
                inputRefs.current[focusIndex].focus();
              }
            }
          });
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    }
  };

  const handleChange = (index, value, e) => {
    console.log("Event", e.key);
    if (!/^\d?$/.test(value)) return;
    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);
    console.log("OO", updatedOtp);

    const result = updatedOtp.join("");
    setuserOtp(result);
    if (value && index < 5 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
    if (value && index < 5) {
      const nextInput = document.querySelector(`input[name=otp-${index + 1}]`);
      if (nextInput) nextInput.focus();
    }
  };

  const handleKeyPress = (e, index) => {
    console.log("Ekey", e.key);
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      const prevInput = document.querySelector(`input[name=otp-${index - 1}]`);
      if (prevInput) prevInput.focus();
    }
    if (index === 5 && e.key === "Enter") {
      // handleSubmit()
      e.preventDefault();
      e.stopPropagation();
      if (clientOTPData.hasOwnProperty("username")) {
        handleClientOtpSuccess();
      } else {
        handleOtpSuccess();
      }
      // Optionally, refocus the current input if needed:
      const currentInput = document.querySelector(`input[name=otp-${index}]`);
      if (currentInput) currentInput.focus();
    }
  };
  const handlePaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData.getData("text");
    const digits = paste.replace(/\D/g, "").slice(0, 6).split(""); // Only digits, max 6
  
    if (digits.length > 0) {
      const newOtp = [...otp];
      digits.forEach((digit, idx) => {
        if (idx < newOtp.length) {
          newOtp[idx] = digit;
          if (inputRefs.current[idx]) {
            inputRefs.current[idx].value = digit;
          }
        }
      });
      setOtp(newOtp);
      const result = newOtp.join("");
      setuserOtp(result);
  
      // Focus the next empty field (or last)
      const nextIndex = digits.length < 6 ? digits.length : 5;
      if (inputRefs.current[nextIndex]) {
        inputRefs.current[nextIndex].focus();
      }
    }
  };
  

  const handleSubmit = () => {
    const code = otp.join("");
    console.log("Submitted OTP:", code);
    if (clientOTPData.hasOwnProperty("username")) {
      handleClientOtpSuccess();
    } else {
      handleOtpSuccess();
    }
  };

  return (
    // <div style={{ marginTop: "20px", height: "100vh" }}>
    <React.Fragment>
    {!showResetPass ? 
    <div className="otp-wrapper">
      <div className="otp-card">
        <div className="otp-icon">
          <img src={lockIcon} />
        </div>
        <h2 className="otp-title">OTP Verification Form</h2>
        <p className="otp-subtitle">Enter OTP</p>

        <div className="otp-input-group">
          {otp.map((digit, index) => (
            <input
              key={index}
              ref={(el) => (inputRefs.current[index] = el)}
              onPaste={(e) => handlePaste(e)}
              name={`otp-${index}`}
              type="text"
              inputMode="numeric"
              maxLength={1}
              className="otp-input"
              value={digit}
              onChange={(e) => handleChange(index, e.target.value, e)}
              onKeyDown={(e) => handleKeyPress(e, index)}
            />
          ))}
        </div>

        <Button className="verify-button" disabled={otp.join("").length <6} onClick={handleSubmit}>
          Verify Code
        </Button>
        <div className="resend-container">
          <p
            className="resend-text"
            onClick={() => {
              reSendOTP();
            }}
          >
            Resend Code
          </p>
        </div>
        <div className="otp-footer">
          <div className="otp-footer-subtext">
            <p>Not receiving OTP?</p>
            <p>Ensure (888) 375-2040 is unblocked in your phone!</p>
          </div>
          <div className="otp-footer-subtext">
            <p>Still not receiving?</p>
            <p>
              Contact us at{" "}
              <a
                className="otp-footer-subtext-link"
                style={{ color: "#2a3da3" }}
                href="mailto:support@assetplanet.com"
              >
                support@assetplanet.com
              </a>
            </p>
          </div>
        </div>
      </div>
      <Loader isLoading={loading}></Loader>
    </div>
    : <ResetPasswordV2 token={token} setResetSuccess={setResetSuccess} otpRes={otpRes} />}
    </React.Fragment>
  );
};

export default OTPValidateV2;
